import { BrowserRouter, Route, Switch } from "react-router-dom";
import StoreRoutes from "./Routes/StoreRoutes";
import UserDashboard from "./pages/UserDashboard/UserDashboard";
import { lazy, Suspense } from "react";
import Loading from "./components/Loading/Loading";
import { getLangBasename } from "./utilities/locale/detectLangFromPath";

const App = () => {
  const UserDashboardLazy = lazy(() => import("./pages/UserDashboard/UserDashboard"));

  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "PageView",
  });

  return (
    <BrowserRouter basename={getLangBasename()}>
      <Switch>
        <Route path="/dashboard-*" exact>
          <Suspense fallback={<Loading />}>
            <UserDashboardLazy />
          </Suspense>
        </Route>
        <Route path="/dashboard" component={UserDashboard} exact>
          <Suspense fallback={<Loading />}>
            <UserDashboardLazy />
          </Suspense>
        </Route>
        <Route path="/" component={StoreRoutes} />
      </Switch>
    </BrowserRouter>
  );
};

export default App;
